import './Navigation.css';

type Page = 'dashboard' | 'statistics' | 'referrals' | 'withdrawals';

interface NavigationProps {
  currentPage: Page;
  onNavigate: (page: Page) => void;
}

export function Navigation({ currentPage, onNavigate }: NavigationProps) {
  const navItems: Array<{ id: Page; icon: string; label: string }> = [
    { id: 'dashboard', icon: '🏠', label: 'Главная' },
    { id: 'statistics', icon: '📊', label: 'Статистика' },
    { id: 'referrals', icon: '👥', label: 'Рефералы' },
    { id: 'withdrawals', icon: '💳', label: 'Вывод' },
  ];

  const handleClick = (page: Page) => {
    // Haptic feedback для Telegram
    window.Telegram?.WebApp?.HapticFeedback?.selectionChanged();
    onNavigate(page);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        {navItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
            onClick={() => handleClick(item.id)}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
            {currentPage === item.id && <div className="nav-indicator" />}
          </button>
        ))}
      </div>
    </nav>
  );
}
